export const commonProps = {
  props: {
    label: String,
    labelI18n: String,
    onlyTitle: String,
    title: String,
    titleI18n: String,
    disabled: Boolean,
    readonly: Boolean,
    cssType: {
      type: String,
      default: "",
    },
  },
};

export const valueProps = {
  props: {
    value: {
      default: "",
      required: true,
    },
  },
};

export const selectBoxProps = {
  props: {
    hiddenDefaultText: {
      type: Boolean,
      default: true,
    },
    defaultText: {
      type: String,
      default: "MFXD-01-01-14-03",
    },
    optionList: Array,
    i18nUse: {
      type: Boolean,
      default: true,
    },
    template: {
      type: String,
      default: "default",
    },
  },
};

export const radioNCheckBoxProps = {
  props: {
    id: {
      type: String,
      required: true,
    },
    dataList: {
      type: Array,
      required: true,
    },
    defaultCheckedValue: {
      type: String,
      default: "",
    },
    i18nUse: {
      type: Boolean,
      default: true,
    },
    isHorizontal: {
      type: Boolean,
      default: false,
    },
  },
};

export const validation = {
  props: {
    errMsgParam: Object,
  },
  data() {
    return {
      isValidator: true,
      useRequired: false,
      validatorParams: {},
    };
  },
};

export const calendarRangeDateSet = {
  props: {
    fromDate: String,
    toDate: String,
    isShowRangeBtn: {
      type: Boolean,
      default: true,
    },
    dateRange: String,
    defaultRangeIndex: {
      type: Number,
      default: 2,
    },
    rangeOption: {
      type: Array,
      default: () => [],
    },
    titleI18n: {
      type: String,
      default: "MFXD-01-01-14-07",
    },
    nextStep: Boolean,
  },
  data() {
    return {
      minDate: "",
      maxDate: "",
      calendarOpened: false,
    };
  },
  created() {
    //minDate ~ maxDate setting
    switch (this.dateRange) {
      case this.$config.CALENDAR_SUBTRACT_FIVE_YEAR: //-5년
        this.maxDate = this.moment().format("YYYYMMDD");
        this.minDate = this.moment().add(-5, "y").format("YYYYMMDD");
        break;
      case this.$config.CALENDAR_ADD_TEN_YEAR: //+10년
        this.minDate = this.moment().add(+1, "d").format("YYYYMMDD");
        this.maxDate = this.moment().add(+10, "y").format("YYYYMMDD");
        break;
      default:
        //-10년
        this.maxDate = this.moment().format("YYYYMMDD");
        this.minDate = this.moment().add(-10, "y").format("YYYYMMDD");
    }
  },
  methods: {
    /**
     * 날짜 범위에 따라 from, to 셋팅
     * @param {Number} index 계산할 날짜 범위 index
     * @param {String} to 기준 날짜(YYYYMMDD)
     * @return 계산된 from 날짜(YYYYMMDD)
     */
    changeDate(index, to) {
      let date = "";

      date = this.setChangeDate(to, index);
      if (index == 0) {
        this.$refs.from.setDate(date);
      } else if (index >= this.$config.CALENDAR_RANGE_3M_AFTER && index <= this.$config.CALENDAR_RANGE_12M_AFTER) {
        return {
          start: this.dateRange == this.$config.CALENDAR_ADD_TEN_YEAR && index == 0 ? this.moment().format("YYYYMMDD") : to,
          end: this.dateRange == this.$config.CALENDAR_ADD_TEN_YEAR && index == 0 ? this.moment().format("YYYYMMDD") : date,
        };
      } else {
        return {
          start: this.dateRange == this.$config.CALENDAR_ADD_TEN_YEAR && index == 0 ? this.moment().format("YYYYMMDD") : date,
          end: this.dateRange == this.$config.CALENDAR_ADD_TEN_YEAR && index == 0 ? this.moment().format("YYYYMMDD") : to,
        };
      }
    },
    /**
     * 시작일과 종료일이 있고, 종료일을 기준으로 시작일을 해당 interval만큼 계산해서 세팅한다.
     * @param {String} endDate 기준 날짜(YYYYMMDD)
     * @param {Number} index 계산할 날짜 범위 index
     *                       1  : 당일
     *                       2  : 1주일 전
     *                       3  : 1개월 전
     *                       4  : 3개월 전
     *                       5  : 6개월 전
     *                       6  : 9개월 전
     *                       7  : 12개월 전
     *                       8  : 1년 전
     *                       9  : 2년 전
     *                       10 : 3년 전
     *                       11 : 4년 전
     *                       12 : 별도 요청 시까지
     * @return 계산된 from 날짜(YYYYMMDD)
     */
    setChangeDate(endDate, sep) {
      var aEndDate = this.moment(endDate).format("YYYY.MM.DD").split(".");
      var aToday = this.moment().format("YYYY.MM.DD").split(".");

      var date = new Date();
      var dminus = 0;
      var mminus = 0;
      var mplus = 0;
      var yminus = 0;
      var from = 0;
      var to = 0;
      var strDate = 0;

      if (sep != 1) {
        date.setYear(aEndDate[0]);
        date.setMonth(Number(aEndDate[1]) - 1);
        date.setDate(aEndDate[2]);
        strDate = date.getDate();
      } else {
        date.setYear(aToday[0]);
        date.setMonth(Number(aToday[1]) - 1);
        date.setDate(aToday[2]);
      }

      switch (sep) {
        case 1:
          // 당일
          from = date.getDate();
          date.setDate(from);
          break;
        case 2:
          // 1주일 전
          dminus = 6;
          from = date.getDate() - dminus;
          date.setDate(from);
          break;
        case 3:
          // 1개월 전
          mminus = 1;
          from = date.getMonth() - mminus;
          date.setMonth(from);
          from = date.getDate() + 1;
          date.setDate(from);
          break;
        case 4:
          // 3개월 전
          mminus = 3;
          from = date.getMonth() - mminus;
          date.setMonth(from);
          from = date.getDate() + 1;
          date.setDate(from);
          break;
        case 5:
          // 6개월 전
          mminus = 6;
          from = date.getMonth() - mminus;
          date.setMonth(from);
          from = date.getDate() + 1;
          date.setDate(from);
          break;
        case 6:
          // 9개월 전
          mminus = 9;
          from = date.getMonth() - mminus;
          date.setMonth(from);
          from = date.getDate() + 1;
          date.setDate(from);
          break;
        case 7:
        case 8:
          // 12개월 전
          // 1년 전
          mminus = 12;
          from = date.getMonth() - mminus;
          date.setMonth(from);
          from = date.getDate() + 1;
          date.setDate(from);
          break;
        case 9:
          // 2년 전
          yminus = 2;
          from = date.getFullYear() - yminus;
          date.setYear(from);
          from = date.getDate() + 1;
          date.setDate(from);
          break;
        case 10:
          // 3년 전
          yminus = 3;
          from = date.getFullYear() - yminus;
          date.setYear(from);
          from = date.getDate() + 1;
          date.setDate(from);
          break;
        case 11:
          // 4년 전
          yminus = 4;
          from = date.getFullYear() - yminus;
          date.setYear(from);
          from = date.getDate() + 1;
          date.setDate(from);
          break;
        case 13:
          // 3개월 후
          mplus = 3;
          to = date.getMonth() + mplus;
          date.setMonth(to);
          to = date.getDate() + 1;
          date.setDate(to);
          break;
        case 14:
          // 6개월 후
          mplus = 6;
          to = date.getMonth() + mplus;
          date.setMonth(to);
          to = date.getDate() + 1;
          date.setDate(to);
          break;
        case 15:
          // 12개월 후
          mplus = 12;
          to = date.getMonth() + mplus;
          date.setMonth(to);
          to = date.getDate() + 1;
          date.setDate(to);
          break;
      }

      if (sep != 1 && sep != 2) {
        if (
          (strDate == 31 && date.getDate() > 1) ||
          (strDate == 30 && date.getDate() != 31 && date.getDate() > 1) ||
          (strDate == 29 && date.getDate() < 30 && date.getDate() > 1) ||
          (strDate == 28 && date.getDate() < 29 && date.getDate() > 1)
        ) {
          date.setDate(1);
        }
      }

      var outPutYear = "";
      var outPutDate = "";
      var outPutMonth = "";

      outPutYear = String(date.getFullYear());
      outPutDate = String(date.getDate());
      outPutMonth = String(date.getMonth() + 1);

      if (outPutDate.length == 1) {
        outPutDate = "0" + outPutDate;
      }

      if (outPutMonth.length == 1) {
        outPutMonth = "0" + outPutMonth;
      }

      return outPutYear + outPutMonth + outPutDate;
    },
  },
};

export const unWatchStore = {
  data() {
    return {
      watchs: [],
    };
  },
};

export const unWatchHook = {
  beforeDestroy() {
    if (this.watchs) {
      this.watchs.forEach(f => f());
    }
  },
};

/**
 * 게시판 watch 설정 - 언어 변경때마다 API 호출
 */
export const watchBoardList = {
  created() {
    this.watchs.push(
      this.$store.watch(
        s => s.lang,
        () => {
          this.firstCall();
        },
      ),
    );
  },
};

/**
 * 게시판 watch 설정 - 언어 변경때마다 리스트로 이동
 */
export const watchBoardDetail = {
  created() {
    this.watchs.push(
      this.$store.watch(
        s => s.lang,
        () => {
          if (this.$route.name == "mmrFinancialStatementsDetail") {
            this.$router.push({
              name: "mmrFinancialStatements",
            });
          } else {
            this.$router.push({
              name: "newsList",
            });
          }
        },
      ),
    );
  },
};
